<template>
  <div class="section">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Section'
}
</script>

<style scoped lang="scss">
.section {
  width: calc(100% - 40px);
  max-width: 1000px;
  background: #fff;
  border-radius: 10px;
  margin: 10px 0;
  padding: 20px 40px;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, .1);
}

.section.transparent {
  background: transparent;
  box-shadow: none;
  padding: 20px 0;
}

.section p {
  line-height: 200%;
}

.section p.small {
  font-size: 0.9em;
  color: #aaa;
}
</style>
